import { createSlice } from "@reduxjs/toolkit";

const browserPopupSlice = createSlice({
  name: "browserPopup",
  initialState: {
    isBrowserPopupBlocked: false,
  },
  reducers: {
    setBrowserPopupBlocked: (state, action) => {
      state.isBrowserPopupBlocked = action.payload;
    },
  },
});

export const { setBrowserPopupBlocked } = browserPopupSlice.actions;
export default browserPopupSlice.reducer;
